var exports = {
  "kL": "ChannelStickersArea.module__container___ZkwzVV",
  "gI": "ChannelStickersArea.module__standalone___ZkwzVV",
  "Qs": "ChannelStickersArea.module__content___ZkwzVV",
  "UV": "ChannelStickersArea.module__stickerPreview___ZkwzVV",
  "HF": "ChannelStickersArea.module__stickerImage___ZkwzVV",
  "od": "ChannelStickersArea.module__stickerInfo___ZkwzVV",
  "Zl": "ChannelStickersArea.module__stickerName___ZkwzVV",
  "Gl": "ChannelStickersArea.module__stickerDescription___ZkwzVV",
  "DT": "ChannelStickersArea.module__removeButton___ZkwzVV",
  "Kk": "ChannelStickersArea.module__icon___ZkwzVV",
};

module.exports = exports;
